import PromoHeader from './components';

export default PromoHeader;
